export function redirectToAuthPage(authPageUrl: string, backUrl: string) {
  const registrationPageLink = `${authPageUrl}?back_url=${backUrl}`;
  window.location.href = registrationPageLink;
}
